<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card color="blue darken-3" class="white--text">
          <v-card-title primary-title>
            <div><h5 class="headline mb-0 mainTitle">សង្ខេបពីសាលា</h5></div>
            <div class="stext">
              <br>លេខកូតសាលា: {{ data.schCode }}
              <br>ឈ្មោះសាលា: {{ data.schNameEN }}
              <br>ឈ្មោះសាលា: {{ data.schNameKH }}
              <br>ប្រភេទសាលា: {{ schTypeToName(data.schType) }}
              <br>នាយក/នាយិកា: {{ data.schDir }}
              <br>សិស្សសរុប: {{ data.enT }} ស្រី: {{ data.enF }}
              <br>បុក្គលិកសរុប: {{ data.teT }} ស្រី: {{ data.teF }}
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'GeoJson2Popup',
  props: ['data'],
  methods: {
    schTypeToName: function (type) {
      // console.log(type)
      if (type === 1) {
        return 'មត្តេយ្យសិក្សា'
      } else if (type === 2) {
        return 'បឋមសិក្សា'
      } else if (type === 3) {
        return 'អនុវិទ្យាល័យ'
      } else if (type > 3) {
        return 'វិទ្យាល័យ'
      }
    }
  }
}
</script>

<style scoped>
  .mainTitle {
    font-weight: bold;
    font-family: "khmer";
    font-size: 14px;
  }
  .sttext {
  font-family: "khmer";
  font-size: 12px;
  }
</style>
